import { render, staticRenderFns } from "./planbtn.vue?vue&type=template&id=5a50882a&scoped=true&"
import script from "./planbtn.vue?vue&type=script&lang=js&"
export * from "./planbtn.vue?vue&type=script&lang=js&"
import style0 from "./planbtn.vue?vue&type=style&index=0&id=5a50882a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a50882a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a50882a')) {
      api.createRecord('5a50882a', component.options)
    } else {
      api.reload('5a50882a', component.options)
    }
    module.hot.accept("./planbtn.vue?vue&type=template&id=5a50882a&scoped=true&", function () {
      api.rerender('5a50882a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/physical/planbtn.vue"
export default component.exports